import { render } from "./PeRegion.vue?vue&type=template&id=907efee6"
import script from "./PeRegion.vue?vue&type=script&lang=js"
export * from "./PeRegion.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__